import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { IconButton } from 'pcln-design-system'
import { RadioMinus, RadioPlus } from 'pcln-icons'
import { lowerCaseFirstCharacter, removeWhiteSpace } from './utils'

export default function OperationButton({
  handleClick,
  iconName,
  isDisabled,
  label
}: InferProps<typeof OperationButton.propTypes>) {
  const modifiedLabel = lowerCaseFirstCharacter(removeWhiteSpace(label))
  const iconButtonId = `traveler-selection-${modifiedLabel}-${iconName}-button`
  const disabled = isDisabled ? ' - disabled' : ''
  const ariaLabel =
    iconName === 'radioMinus'
      ? `Decrease ${label}${disabled}`
      : `Increase ${label}${disabled}`

  const RadioIcon = iconName === 'radioMinus' ? RadioMinus : RadioPlus
  return (
    <IconButton
      aria-label={ariaLabel}
      aria-controls={`${modifiedLabel}-number`}
      id={iconButtonId}
      icon={<RadioIcon size={24} color={isDisabled ? 'border' : 'primary'} />}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (!isDisabled) {
          handleClick()
        }
      }}
      name={iconName}
      size={24}
      style={{ cursor: 'pointer' }}
    />
  )
}

OperationButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  iconName: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
}
